import { StyledSettingsLoadingSkeleton } from "./index.styled";

const SettingsLoadingSkeleton = () => {
  return (
    <StyledSettingsLoadingSkeleton>
      <div className="loading-sections">
        {/* Contact Settings Skeleton */}
        <div className="loading-section">
          <div className="section-header">
            <div className="section-icon" />
            <div className="section-title" />
          </div>
          <div className="section-content">
            <div className="input-group">
              <div className="input-label" />
              <div className="input-field" />
              <div className="input-actions" />
            </div>
            <div className="input-group">
              <div className="input-label" />
              <div className="input-field" />
              <div className="input-actions" />
            </div>
            <div className="input-group">
              <div className="input-label" />
              <div className="input-field" />
              <div className="input-actions" />
            </div>
          </div>
        </div>

        {/* Upload Image Skeleton */}
        <div className="loading-section">
          <div className="section-header">
            <div className="section-icon" />
            <div className="section-title" />
          </div>
          <div className="upload-area">
            <div className="upload-icon" />
            <div className="upload-text" />
            <div className="upload-subtext" />
          </div>
        </div>

        {/* Textarea Sections Skeleton */}
        <div className="loading-section">
          <div className="section-header">
            <div className="section-icon" />
            <div className="section-title" />
          </div>
          <div className="textarea-group">
            <div className="textarea-label" />
            <div className="textarea-field" />
          </div>
          <div className="textarea-group">
            <div className="textarea-label" />
            <div className="textarea-field" />
          </div>
        </div>

        {/* Links Settings Skeleton */}
        <div className="loading-section">
          <div className="section-header">
            <div className="section-icon" />
            <div className="section-title" />
          </div>
          <div className="warning-subtitle">
            <div className="warning-icon" />
            <div className="warning-text" />
          </div>
          <div className="links-content">
            <div className="link-item">
              <div className="link-content">
                <div className="link-name" />
                <div className="link-text" />
              </div>
              <div className="link-actions" />
            </div>
            <div className="link-item">
              <div className="link-content">
                <div className="link-name" />
                <div className="link-text" />
              </div>
              <div className="link-actions" />
            </div>
            <div className="link-item">
              <div className="link-content">
                <div className="link-name" />
                <div className="link-text" />
              </div>
              <div className="link-actions" />
            </div>
          </div>
        </div>

        {/* Email Settings Skeleton */}
        <div className="loading-section">
          <div className="section-header">
            <div className="section-icon" />
            <div className="section-title" />
          </div>
          <div className="section-content">
            <div className="input-group">
              <div className="input-label" />
              <div className="input-field" />
              <div className="input-actions" />
            </div>
            <div className="input-group">
              <div className="input-label" />
              <div className="input-field" />
              <div className="input-actions" />
            </div>
          </div>
        </div>
      </div>
    </StyledSettingsLoadingSkeleton>
  );
};

export default SettingsLoadingSkeleton;
